<template>
  <b-container fluid class="table px-6">
    <b-row>
      <b-col :md="isSuperUserDealer() || isDealer() ? 2 : 3">
        <b-form-select id="select-status" v-model="selectedStatus">
          <option :value="null">Все статусы</option>
          <option value="Работает">Работает</option>
          <option value="Демо">Демо</option>
          <option value="Приостановлена">Приостановлена</option>
          <option value="В архиве">В архиве</option>
        </b-form-select>
      </b-col>
      <b-col v-if="isSuperUserDealer()" md="2" class="pl-0">
        <b-form-select
          id="select-dealer"
          v-model="selectedDealer"
          :options="dealersList"
          value-field="gid"
          text-field="fullname"
        ></b-form-select>
      </b-col>
      <b-col v-else-if="isDealer()" md="2" class="pl-0">
        <b-form-select
          id="select-dealer"
          v-model="selectedDealer"
          :options="dealersList"
          value-field="gid"
          text-field="fullname"
        ></b-form-select>
      </b-col>
      <b-col :md="isSuperUserDealer() || isDealer() ? 2 : 3" class="pl-0">
        <ctk-date-time-picker
          id="groups-users-datepicker"
          v-model="selectedDate"
          label="Дата создания"
          color="#16a34a"
          locale="ru"
          range
          :custom-shortcuts="customShortcuts"
          format="YYYY-MM-DD HH:mm"
          formatted="ll"
        >
        </ctk-date-time-picker>
      </b-col>
      <b-col md="3" class="pl-0">
        <b-input-group class="search">
          <b-form-input v-model="filter" placeholder="Поиск"/>
          <div class="container_search-close"
               @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </b-input-group>
      </b-col>
      <b-col md="auto">
        <b-form-group
            label="Онлайн"
            label-for="is_online"
            label-class="mf-label mb-0"
          >
          <b-form-checkbox
            id="is_online"
            class="d-flex justify-content-center mb-0"
            name="is_online"
            v-model="checkedIsOnline"
          ></b-form-checkbox>
        </b-form-group>
      </b-col>
      <b-col v-if="!isSupport()" offset-md="auto" class="pr-0">
        <div v-if="!isNotAbleToEditBanGroupsUsers()" class="buttons">
          <b-button v-if="servers.length === 1"
                    class="b-upper"
                    variant="success"
                    @click="companyData({server:servers[0].server_alias}, {add:true})">
            + Добавить организацию
          </b-button>
          <b-dropdown v-else-if="servers.length > 1" right class="b-upper" variant="success">
            <template v-slot:button-content>
              + Добавить организацию
            </template>
            <b-dropdown-item v-for="server in servers"
                             :key="server.server_alias"
                             @click="companyData({server:server.server_alias}, {add:true})">
              {{server.server_name}}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" v-if="isSuperUserDealer()" class="mt-3">
        <b-form-group label="Список доступных серверов:" class="mb-1">
          <b-form-radio-group
            id="radio-group-1"
            v-model="selectedServer"
            :options="servers"
            value-field="server_alias"
            text-field="server_name"
            disabled-field="disabled"
            @change="serverCheck"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="d-flex">
      <div v-if="items && items.length" class="filtered-items-number mt-3 mr-auto">Записи с
        {{ currentPage === 1 ? setFirstItem() : ((currentPage-1)*pageOptionSelected)+1 }} до
        {{ calcItems() }} из
        {{ items.length }} (отфильтровано из
        {{ groupsUsers.length }} записей)
      </div>
      <b-button
        v-if="isSuperUserDealer()"
        :disabled="loading"
        class="ml-auto"
        @click="downloadFile">Выгрузить в Excel</b-button>
    </div>

    <b-table
      hover
      show-empty
      responsive
      @row-clicked="rowToggle"
      id="mytable"
      ref="mytable"
      :fields="fields"
      :items="items"
      :busy.sync="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      :filter-function="filterTable"
      @filtered="onFiltered"
      class="mt-3 blue"
      empty-text="Нет данных в таблице"
      empty-filtered-text="Нет данных по вашему запросу"
    >

      //organization
      <template v-slot:head(orgname)="data">
        <i class="fas table fa-sitemap"></i> {{ data.label }}
      </template>
      <template v-slot:cell(orgname)="data">
        <div class="td_wrapper">
          <p class="main-name">{{data.item.orgname}}</p>
          <p class="normal">{{data.item.inn_kpp}}</p>
          <div>
            <b-badge :variant="badgeVariant(data.item.access_status)">{{data.item.access_status}}
            </b-badge>
            <b-badge v-if="isSuperUserDealer()">{{data.item.parent}}
            </b-badge>
            <b-badge v-if="servers.length > 1">{{data.item.server_name}}
            </b-badge>
            <b-badge v-if="hasOnlineUser(data.item)" variant="success">Online</b-badge>
            <b-badge v-if="data.item.is_emulator">Эмулятор</b-badge>
          </div>
        </div>
      </template>

      //info
      <template v-slot:head(info)="data">
        <div class="inline">
          <i class="fas table fa-info-circle"></i> {{ data.label }}
        </div>
      </template>
      <template v-slot:cell(info)="data">
        <div class="td_wrapper">
          <p class="normal">
            <i class="fas table fa-map-marker-alt" v-b-tooltip title="Город"></i>
            {{data.item.city!==null?data.item.city:'Не указан'}}
          </p>
        </div>
      </template>

      //group

      <template v-slot:head(p_gid)="data">
        <i class="fas table fa-folder-open"></i> {{ data.label }}
      </template>
      <template v-slot:cell(p_gid)="data">
        <div class="td_wrapper flex-row justify-content-between">
          <p class="normal bold copy"><i class="fas table fa-users" v-b-tooltip
                                         title="Имя группы"></i> {{data.item.name}}
            <i class="fas table fa-copy"
               @click="copyToClipboard(data.item.name+data.item.p_gid, $event)"
               :id="data.item.name+data.item.p_gid"
               v-b-tooltip.hover
               title="Копировать"></i>
          </p>
          <p class="normal"><i class="fas table fa-home" v-b-tooltip title="ID группы"></i>
            {{data.item.p_gid}}</p>
        </div>
        <div class="user_group">
          <p class="normal"><i class="fas table fa-user" v-b-tooltip title="Имя автора"></i>{{data.item.create_user}}
          </p>
          <p class="normal" v-if="data.item.create_date">{{data.item.create_date.split(' ')[0]}}</p>
        </div>
        <div v-if="data.item.modify_user" class="user_group">
          <p class="normal"><i class="fas table fa-user-edit" v-b-tooltip title="Имя редактора"></i>{{data.item.modify_user}}
          </p>
          <p class="normal" v-if="data.item.modify_date">{{data.item.modify_date.split(' ')[0]}}</p>
        </div>
      </template>

      //parameters

      <template v-slot:head(parameters)="data">
        <div class="inline">
          <i class="fas table fa-file-alt"></i> {{ data.label }}
        </div>
      </template>
      <template v-slot:cell(parameters)="data">
        <div class="td_wrapper">
          <div class="inline-flex">
            <p class="normal"><i class="fas table fa-building" v-b-tooltip title="ID организации"></i></p>
            <p class="normal mb-0 copy">{{data.item.org_id ? data.item.org_id:'Не указан'}}
              <i class="fas table fa-copy"
                 v-if="data.item.org_id"
                 @click="copyToClipboard('OrgID'+data.item.org_id, $event)"
                 :id="'OrgID'+data.item.org_id"
                 v-b-tooltip.hover
                 title="Копировать"></i>
            </p>
          </div>
          <p class="normal">
            <i :class="[data.item.participant_id!=='' ? (data.item.is_inn_correct === 0 ? 'orange fas table fa-monument' : 'fas table fa-monument') : 'red fas table fa-monument']"
               v-b-tooltip title="ID декларанта"></i>
            {{data.item.participant_id!==''?data.item.participant_id:'Не выбран'}}
          </p>
        </div>
      </template>

      //content

      <template v-slot:head(content)="data">
        <i class="fas table fa-file-alt"></i> {{ data.label }}
      </template>
      <template v-slot:cell(content)="data">
        <div class="td_wrapper">
          <p class="normal"><i class="fas table fa-code-branch"></i> Подгрупп:&nbsp;{{data.item.subgroup_count}}
          </p>
          <p class="normal"><i class="fas table fa-id-card"></i> Пользователей:&nbsp;{{data.item.user_count}}
          </p>
        </div>
      </template>

      //actions

      <template v-slot:head(actions)="data">
        <div class="inline">
          <i class="fas table fa-info-circle"></i> {{ data.label }}
        </div>
      </template>
      <template v-slot:cell(actions)="data">
        <div :class="!isNotAbleToEditBanGroupsUsers() ? 'user-button' : 'remove-user-button'">
          <div class="buttons-holder">
            <div class="buttons-box">
              <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary" @click="companyData(data.item, {add:false})"><i
                class="fas fa-pencil-alt"></i></b-button>
              <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary" @click="userData(data.item,{add:true, alias: data.item.server_alias, p_gid: data.item.p_gid, orgname: data.item.orgname, opf: data.item.opf, inn_kpp: data.item.inn_kpp, parent_id: data.item.parent_id })"><i
                class="fas fa-user-plus"></i></b-button>
            </div>
          </div>
          <b-button class="more-info"
                    :id="data.item.p_gid +'popover'"><i class="fas table fa-ellipsis-h"></i>
          </b-button>
          <b-popover :target="data.item.p_gid +'popover'"
                     triggers="focus">
            <ul class="popoverButtons">
              <li v-if="!isNotAbleToEditBanGroupsUsers()" @click="companyData(data.item, {add:false})"><i class="fas fa-pencil-alt"></i>
                <span>Изменить организацию</span>
              </li>
              <li v-if="!isNotAbleToEditBanGroupsUsers()" @click="subGroupData(data.item,{ add: true, parent_id: data.item.parent_id })"><i class="fas fa-building"></i>
                <span>Добавить отдел/организацию</span>
              </li>
              <li @click="FCSProfile(data.item, { alias: null, parent_id: data.item.parent_id })"><i class="fas fa-address-card"></i>
                <span>Профиль ФТС</span>
              </li>
              <li v-if="!isNotAbleToEditBanGroupsUsers()" @click="userData(data.item,{add:true, alias: data.item.server_alias, p_gid: data.item.p_gid, orgname: data.item.orgname, opf: data.item.opf, inn_kpp: data.item.inn_kpp, parent_id: data.item.parent_id })"><i class="fas fa-user-plus"></i>
                <span>Добавить пользователя</span>
              </li>
              <!-- li @click="billingData(data.item)"><i class="fas fa-hand-holding-usd"></i>
                <span>Профиль биллинга</span>
              </li -->
              <li v-if="data.item.access_status=='Приостановлена' || data.item.access_status=='В архиве'"
                  @click="setArchive(data.item, $event)">
                <i class="far fa-file-archive"></i>
                <span v-if="data.item.access_status=='Приостановлена'">Добавить в архив</span>
                <span v-else-if="data.item.access_status=='В архиве'">Извлечь из архива</span>
              </li>
            </ul>
          </b-popover>
        </div>
      </template>

      <template v-slot:row-details="data">
        <b-row class="users">
          <b-col md="3" lg="3" xl="3" v-for="(user, index) in data.item.users_json" :key="index"
                 class="p-0 pr-5 pb-4">
            <div :class="userStyle(user)" class="overflow-hidden">
              <div class="td_wrapper">
                <div class="user_data">
                  <p class="subgroup bold copy"><i class="fas table fa-user" v-b-tooltip title="Логин"></i><span> {{user.login}}</span>
                    <i class="fas table fa-copy"
                       @click="copyToClipboard(user.login + user.p_id, $event)"
                       :id="user.login + user.p_id"
                       v-b-tooltip.hover
                       title="Копировать"></i>
                  </p>
                  <i class="fas fa-user-edit user_card_button"
                     v-if="!isNotAbleToEditBanGroupsUsers()"
                     @click="userData(user, { add: false, alias: data.item.server_alias, p_gid: data.item.p_gid, orgname: data.item.orgname, opf: data.item.opf, inn_kpp: data.item.inn_kpp, parent_id: data.item.parent_id })"
                     v-b-tooltip.hover
                     title="Изменить"></i>
                </div>
                <div class="user_data">
                  <p class="normal"><i class="fas table fa-id-card" v-b-tooltip title="ФИО"></i>
                    {{user.name}}</p>
                  <p class="normal">
                    <i class="fas table fa-home" v-b-tooltip title="ID пользователя"></i> {{user.p_id}}
                  </p>
                </div>
                <div class="user_data">
                  <p class="normal">
                    <i class="fas table fa-user-tag" v-b-tooltip title="Роль"></i>
                    {{user.role}}</p>
                  <p class="normal" v-if="user.selfsign!=='Нет'">
                    <i class="fab table fa-usb mr-0" v-b-tooltip title="Требуется ЭП"></i>
                  </p>
                </div>
                <div v-if="isAbleToAddEmailSettings()" class="user_data">
                  <p class="normal">
                    <i :class="!user.p_notification ? 'fas table fa-envelope opacity' : 'fas table fa-envelope-open-text'" style="margin-left: -2px;"></i>
                    <span :class="!user.p_notification ? 'opacity' : ''">{{!user.p_notification ? 'Без e-mail оповещения' : 'С e-mail оповещением'}}</span>
                  </p>
                  <p class="normal" v-if="user.in_online">
                    <b-badge variant="success">Online</b-badge>
                  </p>
                </div>
                <div v-else class="user_data flex-row-reverse">
                  <p class="normal" v-if="user.in_online">
                    <b-badge variant="success">Online</b-badge>
                  </p>
                </div>
                <div v-if="user.create_user" class="user_data">
                  <p class="user-create-info normal mr-3 mb-1"><i class="fas table fa-user" v-b-tooltip title="Имя автора" style="margin-left: -2px;"></i>{{user.create_user}}
                  </p>
                  <p class="user-create-info normal mb-1" v-if="user.create_date">{{user.create_date.split(' ')[0]}}</p>
                </div>
                <div v-if="user.modify_user" class="user_data">
                  <p class="user-create-info normal mr-3"><i class="fas table fa-user-edit" v-b-tooltip title="Имя редактора"></i>{{user.modify_user}}
                  </p>
                  <p class="user-create-info normal" v-if="user.modify_date">{{user.modify_date.split(' ')[0]}}</p>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-for="group in data.item.subgroups_json" class="user-subgroup" :key="group.name">
          <div :class="[group.class==='active'?'subgroups set-active mb-4':'subgroups mb-4']">
            <div class="subgroup_items">
              <p class="main-name mr-6">Подгруппа: {{group.fullname}}</p>
              <p class="subgroup bold copy mr-6">
                <i class="fas table fa-folder-open" v-b-tooltip title="Имя группы"></i> {{group.name}}
                <i class="fas table fa-copy"
                   @click="copyToClipboard(group.fullname+group.p_gid, $event)"
                   :id="group.fullname+group.p_gid"
                   v-b-tooltip.hover
                   title="Копировать"></i>
              </p>
              <p class="subgroup bold copy mr-6">
                <i class="fas table fa-home" v-b-tooltip title="ID группы"></i>{{group.p_gid}}
                <i class="fas table fa-copy"
                   @click="copyToClipboard('tooltip'+group.p_gid, $event)"
                   :id="'tooltip'+group.p_gid"
                   v-b-tooltip.hover
                   title="Копировать"></i>
              </p>
              <p class="subgroup bold" v-show="group.is_org">
                <i :class="[group.participant_id!==''?'fas table fa-monument':'fas table fa-monument red']"
                   v-b-tooltip title="ID декларанта"></i>{{group.participant_id!==''?group.participant_id:'Не выбран'}}
              </p>
              <b-badge v-if="group.is_emulator">Эмулятор</b-badge>
            </div>
            <div class="buttons-holder_subgroup">
              <div class="buttons-box">
                <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary"
                          @click="subGroupData(group,{add:false, alias: data.item.server_alias, parent_id: data.item.parent_id })"><i
                  class="fas fa-pencil-alt"></i></b-button>
                <b-button v-if="!isNotAbleToEditBanGroupsUsers()" class="b-table" variant="outline-secondary" @click="userData(data.item,{add:true, subgroup_p_gid: group.p_gid, alias: data.item.server_alias, p_gid: data.item.p_gid, orgname: data.item.orgname, opf: data.item.opf, inn_kpp: data.item.inn_kpp, parent_id: data.item.parent_id })"><i
                  class="fas fa-user-plus"></i></b-button>
                <b-button v-if="group.is_org" class="b-table" variant="outline-secondary"
                          @click="FCSProfile(group, { alias: data.item.server_alias, parent_id: data.item.parent_id })"><i
                  class="fas fa-address-card"></i></b-button>
              </div>
            </div>
          </div>

          <b-row class="users">
            <b-col md="4" lg="3" xl="3" v-for="(subuser, index) in group.users" :key="index"
                   class="p-0 pr-5 pb-4">
              <div :class="userStyle(subuser)">
                <div class="td_wrapper">
                  <div class="user_data">
                    <p class="subgroup bold copy"><i class="fas table fa-user" v-b-tooltip title="Логин"></i>
                      <span>{{subuser.login}}</span>
                      <i class="fas table fa-copy"
                         @click="copyToClipboard(subuser.login+subuser.p_id, $event)"
                         :id="subuser.login+subuser.p_id"
                         v-b-tooltip.hover
                         title="Копировать"></i>
                    </p>
                    <div>
                      <i class="fas fa-user-edit user_card_button"
                         v-if="!isNotAbleToEditBanGroupsUsers()"
                         @click="userData(subuser,{add:false, alias: data.item.server_alias, p_gid:data.item.p_gid, subgroup_p_gid: group.p_gid, orgname: group.fullname, opf: group.opf, inn_kpp: data.item.inn_kpp, parent_id: data.item.parent_id })"
                         v-b-tooltip.hover
                         title="Изменить"></i>
                    </div>
                  </div>
                  <div class="user_data">
                    <p class="normal"><i class="fas table fa-id-card" v-b-tooltip title="ФИО"></i>
                      {{subuser.name}}</p>
                    <p class="normal"><i class="fas table fa-home" v-b-tooltip title="ID пользователя"></i> {{subuser.p_id}}</p>
                  </div>
                  <div class="user_data">
                    <p class="normal"><i class="fas table fa-user-tag" v-b-tooltip title="Роль"></i>
                      {{subuser.role}}</p>
                    <p class="normal" v-if="subuser.selfsign!=='Нет'"><i class="fab fa-usb mr-0" v-b-tooltip
                                                                         title="Требуется ЭП"></i>
                    </p>
                    <p class="normal" v-if="subuser.in_online">
                      <b-badge variant="success">Online</b-badge>
                    </p>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-row>
      </template>
      <div slot="table-busy" class="text-xl-center text-lg-center text-md-center text-sm-left text-left text-secondary my-2">
          <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загружаем данные...</strong>
      </div>
    </b-table>

    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions"
                       v-model="perPage"
                       @change="saveOptionSelected"/>
      </b-form>
      <b-pagination align="center"
                    prev-text="&lt;"
                    first-text="&lt;&lt;"
                    next-text="&gt;"
                    last-text="&gt;&gt;"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    class="my-6">
      </b-pagination>
    </div>
    <company :ModData="modalParamsCompany" @goToFirstPage="goToFirstPage" ref="company" @reloadGroups="reloadGroups">
    </company>
    <user :ModData="modalParamsUser" ref="user" @reloadGroups="reloadGroups">
    </user>
    <fcs-profile :ModData="modalParamsUser" ref="fcsProfile" @reloadGroups="reloadGroups">
    </fcs-profile>
    <sub-group :ModData="modalParamsUser" ref="subGroup" @reloadGroups="reloadGroups">
    </sub-group>
    <billing :ModData="modalParamsUser" ref="billing">
    </billing>
  </b-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import Company from './modalForms/Company'
import User from './modalForms/User'
import FcsProfile from './modalForms/FCSProfile'
import SubGroup from './modalForms/SubGroup'
import Billing from './modalForms/Billing'
import CtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import moment from 'moment'

export default {
  name: 'groups-users',
  components: {
    CtkDateTimePicker,
    Company,
    User,
    FcsProfile,
    Billing,
    SubGroup
  },
  data () {
    return {
      fields: [
        { key: 'orgname', label: 'Организация', sortable: true },
        { key: 'info', label: 'Информация', sortable: false },
        { key: 'p_gid', label: 'Группа', sortable: true },
        { key: 'parameters', label: 'Параметры', sortable: false },
        { key: 'content', label: 'Содержимое', sortable: false },
        { key: 'actions', label: 'Действия', sortable: false }
      ],
      items: null,
      currentPage: 1,
      totalRows: null,
      perPage: 5,
      pageOptions: [5, 10, 20, 50],
      sortBy: 'p_gid',
      sortDesc: true,
      sortDirection: 'asc',
      filter: null,
      confirm: '',
      item: {},
      id: null,
      onclickColor: 'gray',
      customShortcuts: [
        { key: 'thisWeek', label: 'Эта неделя', value: 'isoWeek' },
        { key: 'thisMonth', label: 'Этот месяц', value: 'month' },
        { key: 'thisYear', label: 'Этот год', value: 'year' }
      ],
      day: null,
      month: null,
      year: null,
      hours: null,
      minutes: null,
      modalData: null,
      pageOptionSelected: 5,
      selectedServer: null,
      supportCheck: false,
      loading: false
    }
  },
  watch: {
    items () {
      this.totalRows = this.items.length
    },
    dealers () {
      this.itemsTable = JSON.parse(JSON.stringify(this.dealers))
      this.items = this.itemsTable
    },
    groupsUsers () {
      this.itemsTable = JSON.parse(JSON.stringify(this.groupsUsers))
      this.items = this.itemsTable
    }
  },
  mounted () {
    if (this.isSuperUserDealer()) {
      this.selectedServer = this.servers[0].server_alias
      this.getAllDealers(this.selectedServer)
      this.getAllDealersGroups({ server: this.selectedServer, reload: true })
        .then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.groupsUsers))
          }
        )
    } else if (this.isDealer()) {
      this.selectedServer = this.servers[0].server_alias
      this.getDealers(this.selectedServer)
      this.getGroupsUsers()
        .then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.groupsUsers))
          }
        )
    } else {
      this.getGroupsUsers()
        .then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.groupsUsers))
          }
        )
    }
    this.getBillingTypes()
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    isAbleToAddEmailSettings () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'email_settings'
      })
      return (hasRights.length > 0)
    },
    isSuperUserDealer () {
      let hasRights = this.userInfo.rights.filter(item => {
        return item === 'dealer_users'
      })

      if (hasRights.length === 0) {
        hasRights = this.userInfo.rights.filter(item => {
          return item === 'support'
        })
      }
      return (hasRights.length > 0)
    },
    isDealer () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'dealer_subdealers'
      })
      return (hasRights.length > 0)
    },
    isSupport () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'support'
      })
      return (hasRights.length > 0)
    },
    isNotAbleToEditBanGroupsUsers () {
      const hasRights = this.userInfo.rights.filter(item => {
        return item === 'edit_ban_users_groups'
      })
      return (hasRights.length > 0)
    },
    badgeVariant (data) {
      if (data === 'Работает') {
        return 'success'
      } else if (data === 'Приостановлена') {
        return 'danger'
      } else if (data === 'Демо') {
        return 'warning'
      } else if (data === 'В архиве') {
        return 'secondary'
      }
    },
    hasOnlineUser (data) {
      return ((data.users_json.length > 0 && data.users_json.some(x => x.in_online)) ||
        (data.subgroups_json.length > 0 && data.subgroups_json.some(x => x.users.length > 0 && x.users.some(y => y.in_online))))
    },
    clearField () {
      this.filter = ''
    },
    userStyle (user) {
      if (user.class === 'active') {
        return 'user_card set-active'
      } else if (user.role === 'Banned users' || user.role === 'Заблокирован') {
        return 'user_card opacity'
      } else {
        return 'user_card'
      }
    },
    rowToggle (row, index, event) {
      if (row._showDetails !== true && event.target.nodeName !== 'p') {
        Vue.set(row, '_showDetails', true)
      } else if (row._showDetails === true) {
        Vue.set(row, '_showDetails', false)
      }
    },
    copyToClipboard (id, e) {
      const self = this
      e.stopPropagation()
      const copyedText = e.target.parentNode.outerText
      var textArea = document.createElement('textarea')
      textArea.value = copyedText
      document.body.appendChild(textArea)
      textArea.select()
      try {
        const successful = document.execCommand('copy')
        const msg = successful ? 'successful' : 'unsuccessful'
        self.$root.$emit('bv::hide::tooltip', id)
        e.target.setAttribute('data-original-title', 'Скопировано')
        e.target.setAttribute('style', 'color:#40b539')
        self.$root.$emit('bv::show::tooltip', id)
        setTimeout(function () {
          e.target.setAttribute('data-original-title', 'Копировать')
          e.target.setAttribute('style', 'color:#78909C')
        }, 1500)
        console.log('Fallback: Copying text command was ' + msg)
      } catch (err) {
        console.error('Fallback: Oops, unable to copy', err)
      }
      document.body.removeChild(textArea)
    },
    toStr (value) {
      if (value === null || typeof value === 'undefined') {
        return ''
      } else if (value instanceof Object) {
        return Object.keys(value).sort().map(key => toString(value[key])).join(' ')
      } else {
        return String(value)
      }
    },
    setFirstItem () {
      if (this.items.length < 1) {
        return 0
      } else {
        return 1
      }
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    calcItems () {
      if (this.currentPage === 1) {
        if ((this.currentPage) + this.pageOptionSelected < this.items.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.items.length
        }
      } else {
        if (((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected < this.items.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.items.length
        }
      }
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    filterTable (row, filter) {
      function fieldForFilter (field) {
        if (field && field.toString().toLowerCase().includes(filter.toLowerCase())) {
          return true
        } else return false
      }
      function subgroupForFilter (arr) {
        if (arr.length > 0 && arr.some(obj => fieldForFilter(obj.fullname) ||
          fieldForFilter(obj.name) ||
          fieldForFilter(obj.participant_id) ||
          fieldForFilter(obj.p_gid) ||
          userForFilter(obj.users))) {
          return true
        } else return false
      }
      function userForFilter (arr) {
        if (arr.length > 0 && arr.some(obj => fieldForFilter(obj.login) || fieldForFilter(obj.name) || fieldForFilter(obj.role))) {
          return true
        } else return false
      }
      if (fieldForFilter(row.access_status) ||
        fieldForFilter(row.city) ||
        fieldForFilter(row.create_date) ||
        fieldForFilter(row.create_user) ||
        fieldForFilter(row.inn_kpp) ||
        fieldForFilter(row.modify_date) ||
        fieldForFilter(row.modify_user) ||
        fieldForFilter(row.name) ||
        fieldForFilter(row.opf) ||
        fieldForFilter(row.orgname) ||
        fieldForFilter(row.p_gid) ||
        fieldForFilter(row.participant_id) ||
        fieldForFilter(row.tariff) ||
        subgroupForFilter(row.subgroups_json) ||
        userForFilter(row.users_json) ||
        fieldForFilter(row.org_id)) {
        return true
      } else {
        return false
      }
    },
    companyData (data, add) {
      this.supportCheck = false
      const dataAdd = data
      dataAdd.add = add.add
      if (!add.add) this.supportCheck = this.isSupport()
      this.$refs.company.modalCompany(dataAdd)
    },
    userData (data, add) {
      this.supportCheck = false
      const isSubgroupUser = Object.keys(add).indexOf('subgroup_p_gid')
      if (isSubgroupUser !== -1) {
        data.subgroup_p_gid = add.subgroup_p_gid
      } else {
        data.subgroup_p_gid = null
      }
      data.orgname = add.orgname
      data.opf = add.opf
      data.inn_kpp = add.inn_kpp
      const dataAdd = { ...data }
      dataAdd.add = add.add
      this.supportCheck = this.isSupport()
      if (!add.add) {
        dataAdd.alias = add.alias
        dataAdd.p_gid = add.p_gid
      }
      this.$refs.user.modalUser(dataAdd)
    },
    FCSProfile (data, alias) {
      this.supportCheck = false
      const dataSend = data
      this.supportCheck = this.isSupport()
      if (alias.alias !== null) {
        dataSend.alias = alias.alias
        this.$refs.fcsProfile.modalSubgroupFCS(dataSend)
      } else {
        this.$refs.fcsProfile.modalGroupFCS(dataSend)
      }
    },
    subGroupData (data, add) {
      this.supportCheck = false
      const dataAdd = data
      dataAdd.add = add.add
      if (!add.add) {
        dataAdd.alias = add.alias
      }
      this.supportCheck = this.isSupport()
      this.$refs.subGroup.modalSubgroup(dataAdd)
    },
    billingData (data) {
      this.$refs.billing.modalBilling(data)
    },
    setArchive (row) {
      if (!this.isSupport()) {
        this.sendToArchive(row).then(
          () => {
            this.reloadGroups(row)
          }
        )
      }
      this.$root.$emit('bv::hide::popover', row.p_gid + 'popover')
    },
    ...mapActions('groupsUsers', [
      'getGroupsUsers',
      'sendToArchive',
      'getAllDealersGroups',
      'getAllDealers',
      'getDealers',
      'downloadExcelFile',
      'getBillingTypes'
    ]),
    ...mapMutations('groupsUsers', [
      'setFilterStatus',
      'setFilterDate',
      'setFilterDealer',
      'setActiveElement',
      'setFilterOnline'
    ]),
    serverCheck () {
      this.getAllDealers(this.selectedServer)
      this.selectedDealer = null
      this.getAllDealersGroups({ server: this.selectedServer, reload: true })
        .then(
          () => {
            this.items = JSON.parse(JSON.stringify(this.groupsUsers))
          }
        )
    },
    goToFirstPage () {
      this.currentPage = 1
    },
    reloadGroups (response) {
      if (this.isSuperUserDealer()) {
        this.getAllDealersGroups({ server: this.selectedServer, reload: false }).then(() => {
          this.setActiveElement(response)
        })
      } else {
        this.getGroupsUsers(false).then(() => {
          this.setActiveElement(response)
        })
      }
    },
    downloadFile () {
      this.loading = true
      const params = { server_alias: this.selectedServer }
      if (this.filterOnline) params.in_online = this.filterOnline
      if (this.filterDealer) params.parent_id = this.filterDealer
      if (this.filterDate?.start) params.create_date_start = this.moment(this.filterDate.start).format('DD.MM.YYYY')
      if (this.filterDate?.end) params.create_date_end = this.moment(this.filterDate.end).format('DD.MM.YYYY')
      if (this.filterStatus) params.access_status = this.filterStatus
      this.downloadExcelFile(params).then(
        (result) => {
          const fileName = 'organisations_users.xlsx'
          const downloadUrl = window.URL.createObjectURL(new Blob([result.data]))
          const link = document.createElement('a')
          link.href = downloadUrl
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          link.remove()
          URL.revokeObjectURL(downloadUrl)
          this.$nextTick(() => {
            this.loading = false
          })
        },
        (error) => {
          this.loading = false
          console.log(error)
        }
      )
    }
  },
  computed: {
    ...mapState(
      {
        modalParamsCompany: state => state.groupsUsers.modalParamsCompany,
        modalParamsUser: state => state.groupsUsers.modalParamsUser,
        isBusy: state => state.groupsUsers.isBusy,
        dealers: state => state.groupsUsers.dealers,
        dealersList: state => state.groupsUsers.dealersList,
        userInfo: state => state.authorization.userInfo,
        filterStatus: state => state.groupsUsers.filterStatus,
        filterDealer: state => state.groupsUsers.filterDealer,
        filterDate: state => state.groupsUsers.filterDate,
        filterOnline: state => state.groupsUsers.filterOnline
      }
    ),
    ...mapGetters(
      {
        groupsUsers: 'groupsUsers/filteredGroupsUsers'
      }
    ),
    userInfoOrgId () {
      return this.userInfo.company && this.userInfo.company.gid ? this.userInfo.company.gid : null
    },
    selectedStatus: {
      get () {
        return this.filterStatus
      },
      set (value) {
        this.setFilterStatus(value)
      }
    },
    selectedDate: {
      get () {
        return this.filterDate
      },
      set (value) {
        this.setFilterDate(value)
      }
    },
    selectedDealer: {
      get () {
        return this.filterDealer
      },
      set (value) {
        this.setFilterDealer(value)
      }
    },
    servers () {
      const arr = []
      this.userInfo.piportals.map(item => {
        arr.push({ server_name: item.name, server_alias: item.alias })
      })
      return arr
    },
    checkedIsOnline: {
      get () {
        return this.filterOnline
      },
      set (value) {
        this.setFilterOnline(value)
      }
    }
  }
}
</script>

<style scoped>
  .table.red {
    color: #e7161a;
  }
  .table.orange {
    color: #fdb611;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
  }

  .container_search-close:hover {
    border-radius: 50%;
    background-color: #acacac;
  }

  .search-close {
    font-size: 18px;
    color: #acacac;
    cursor: pointer;
    line-height: 18px;
    width: 18px;
    text-align: center;
    margin-bottom: 2px;
  }

  .container_search-close:hover > span {
    color: #fff;
  }

  #select-status, #select-dealer {
    font-size: 14px;
    height: 40px;
  }

  .opacity {
    opacity: 0.6;
  }

  .popover.popover-body {
    padding: 0;
  }

  .qwerty {
    display: flex;
    flex-direction: column;
  }

  p.copy:hover i.fa-copy {
    visibility: visible;
  }

  i.fa-copy {
    visibility: hidden;
    margin: 0;
  }

  .buttons-holder {
    display: flex;
    visibility: hidden;
  }

  button.b-table {
    padding: 0.1rem 0.375rem;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    border: 2px solid #cfd8dc;
  }

  button.b-table:hover {
    color: #fff;
  }

  tr:hover .buttons-holder, .b-table-has-details .buttons-holder {
    visibility: visible;
  }

  .buttons-holder_subgroup {
    display: flex;
    visibility: hidden;
  }

  .subgroups:hover .buttons-holder_subgroup {
    visibility: visible;
  }

  .table .table {
    background-color: unset;
  }

  .user_card_button {
    font-size: 16px;
    color: #78909C;
    margin-right: 0;
    visibility: hidden;
  }

  .user_card_button:hover {
    color: #37474F;
  }

  .user_card:hover .user_card_button {
    visibility: visible;
  }

  .more-info {
    display: flex;
    align-items: center;
    background-color: unset;
    padding: 0;
    margin: 0;
    border: none;
    box-shadow: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0.1rem 0.375rem;
  }

  .more-info > .table {
    font-size: 20px;
  }

  .btn-secondary:not(:disabled):not(.disabled):active:focus {
    /*box-shadow: none;*/
  }

  .btn-secondary:not(:disabled):not(.disabled):active {
    background-color: #Fff;
  }

  select {
    -webkit-appearance: none;
    cursor: pointer;
  }

  .td_wrapper {
    display: flex;
    flex-direction: column;
  }

  i.table {
    width: 20px;
    height: 20px;
    color: #78909C;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  i.fa-search {
    width: 36px;
    height: 36px;
  }

  p.main-name {
    font-family: "PT Root UI Bold", Tahoma, Geneva, Verdana, sans-serif !important;
    color: #37474F;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0;
  }

  p.normal {
    color: #37474F;
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 16px;
    display: inline-flex;
    align-items: baseline;
    margin-bottom: 8px;
  }

  p.subgroup {
    display: inline-flex;
    color: #37474F;
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 16px;
    margin-bottom: 0;
    align-items: baseline;
    word-break: break-all;
  }

  .bold {
    font-weight: bold;
  }

  .users {
    margin: 0;
  }

  .inline {
    display: inline-flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .b-table {
    padding: 0.275rem;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    border: 2px solid #cfd8dc;
    color: #78909c;
  }

  .btn.b-table:hover i {
    color: #fff;
  }

  .user_data {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    /*flex-wrap: wrap;*/
  }

  .user_group {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    flex-wrap: wrap;
  }

  .user_card {
    height: 100%;
    padding: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  }

  .user_card:hover {
    cursor: pointer;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
  }

  .user-subgroup {
    display: flex;
    flex-direction: column;
    margin: 0;
    flex-wrap: nowrap;
    /*border: 4px solid #CFD8DC;*/
  }

  .subgroups {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 15px;
    margin: 0 -15px;
    background-color: #F5F7F8;
    min-height: 44px;
  }

  .set-active {
    background-color: #c3e6cb;
  }

  .subgroup_items {
    display: inline-flex;
    align-items: center;
  }

  .cards .card {
    margin: 5px;
  }

  .custom-select {
    font-size: 12px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
  }

  .user-button {
    display: flex;
    justify-content: flex-start;
  }

  .remove-user-button {
    display: flex;
    justify-content: flex-end;
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .table {
    margin-bottom: 0;
  }

  #mytable {
    width: 100%;
    table-layout: fixed;
  }

  .wrap {
    display: flex;
    justify-content: flex-end;
  }

  table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::after {
    right: 0.75em;
  }

  ul.rights {
    padding: 0;
  }

  .input-group > .form-control:not(:last-child), .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    font-size: 14px;
    height: 40px;
  }

  .input-group i {

    right: 0px;
    position: absolute;
    pointer-events: none;
    padding: 10px;
    z-index: 99;
    color: #9ba3a7;
  }

  li.rights {
    list-style: none;
    border: #37474F 1px solid;
    background-color: #546E7A;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    color: #ffffff;
    text-align: center;
  }

  .buttons-box {
    display: flex;
  }

  ul.popoverButtons {
    list-style: none;
    cursor: pointer;
    margin-right: 0rem;
    border: none;
    color: #78909c;
    margin-bottom: 0;
    padding-inline-start: 0;
    width: 100%;
  }

  ul.popoverButtons > li {
    padding: 9px;
  }

  ul.popoverButtons > li:not(:last-child) {
    padding: 9px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  ul.popoverButtons > li > span {
    font-size: 14px;
    line-height: 20px;
    color: #37474F;
  }

  ul.popoverButtons > li > i {
    height: 24px;
    width: 24px;
    font-size: 16px;
    text-align: center;
    margin-right: 4px;
  }

  ul.popoverButtons > li:hover {
    padding: 9px;
    background-color: #ECEFF1;
  }

  .b-upper {
    margin-right: 1rem;
  }

  .buttons-holder_subgroup {
    display: flex;
    visibility: hidden;
  }

  .subgroups:hover .buttons-holder_subgroup {
    visibility: visible;
  }

  .filtered-items-number {
    font-size: 14px;
  }

  .user-create-info {
    font-size: 13px !important;
  }
</style>
